/* 
Importing the components and dependencies for the view
*/
import CardSlider from "../../components/Card/CardCarousel/CardSlider";
import * as service from "./SalesReport.service.js";
import { GetUserId, GetUserDetails } from "../../config/app.config.js";
import StatusReports from "../../components/Reports/StatusReports/StatusReports";
import SalesReport from "../../components/Reports/SalesReport/SalesReportComponent";
import DateFilter from "../../components/DateFilterComponent/DateFilter";
import GroupBy from "../../components/GroupByComponent/GroupBy";
import { mapGetters } from "vuex";

/* 
Logics for the SalesReport View
*/
export default {
  components: {
    CardSlider,
    StatusReports,
    SalesReport,
    DateFilter,
    GroupBy,
  },
  data() {
    return {
      ProjectionCardList: [],
      loading: false,
      ReportPeriodList: [],
      CurrentPeriod: {},
      apiFilterParms: {},
      DisablePriorFilterPeriod: false,
      DisableNextFilterPeriod: true,
    };
  },
  computed: {
    ...mapGetters([
      "getActiveReportMenu",
      "getSelectedArea",
      "getSelectedTeam",
      "getSelectedBranch",
      "getFilterPeriod",
      "getFinancialYear",
      "getCurrentFilters",
      "getSelectedGroupBy",
    ]),
  },

  created() {},

  mounted() {
    let context = this;
    var queryParameters = this.$route.query;
    this.$store.commit("setActiveReportMenu", queryParameters);

    setTimeout(() => {
      context.GetProjectionCardDeatails();
    }, 2000);
  },
  methods: {
    //Fetching the Data for showing the projection cards in the sea cargo
    async GetProjectionCardDeatails() {
      if (
        this.getSelectedArea.hasOwnProperty("Area") == false ||
        this.getCurrentFilters.CurrentYear == null ||
        this.getFilterPeriod.length == 0 ||
        !this.getActiveReportMenu.Name
      ) {
        this.ProjectionCardList = [];
        return false;
      }

      //List of cards at the top of the page
      var listProjections = [];

      var result = await service.GetCategoryListDetails(
        this.getSelectedArea.Area,
        this.getSelectedTeam.Team,
        this.getSelectedBranch.Office,
        this.getCurrentFilters.CurrentYear,
        this.getCurrentFilters.Month,
        this.getActiveReportMenu.Name,
        this.getSelectedGroupBy
      );

      if (result.error == false && result.data != null) {
        {
          listProjections = result.data.Table;
          let listCardData = [];
          this.ProjectionCardList = [];

          listProjections.forEach((item) => {
            const cardData = {
              Text1: item.Text1,
              Text2: item.Text2,
              Title: item.Title,
              Icon: item.Icon,
              Icon_Title: item.Icon_Title,
              TileColor: item.Card_Color,
              Score: item.Score,
              Score_Color: item.score_color,
              DrillDown_Details: item.DrillDown_Details
                ? JSON.parse(item.DrillDown_Details)
                : null,
              Product: item.product,
              IsReportType: item.IsReportType,
              IconColor: item.IconColor ? item.IconColor : item.Card_Color,
              isMarqueeText:
                item.isMarqueeText == undefined
                  ? true
                  : item.isMarqueeText == true
                  ? true
                  : false,
            };

            listCardData.push(cardData);
          });

          this.ProjectionCardList = listCardData;
        }
      }
    },
  },
  watch: {
    async "getSelectedArea.Area"() {
      await this.GetProjectionCardDeatails();
    },
    async "getSelectedTeam.Team"() {
      await this.GetProjectionCardDeatails();
    },
    async "getSelectedBranch.Office"() {
      await this.GetProjectionCardDeatails();
    },
    async "getActiveReportMenu.Name"() {
      await this.GetProjectionCardDeatails();
    },
    async getCurrentFilters() {
      await this.GetProjectionCardDeatails();
    },
    async getSelectedGroupBy() {
      await this.GetProjectionCardDeatails();
    },
  },
};
